module.exports = __webpack_public_path__ + "static/contact_particles-4d657d443bfd61e395181457803e0f2f.png";